import axios from "axios";
import { urlRequest } from "../components/constants";

export const getFam = async () => {
  let url = urlRequest + "users/getfamiliares";
  let tokenSend = localStorage.getItem("token");
  let headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${tokenSend}`,
  };
  return await axios
    .get(url, { headers })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      alert("Error al recibir los familiares");
    });
};
